module.exports = __webpack_public_path__ + "img/empty-hookah-red.8f0d560.svg";